export const INCENTIVES_QUERY_STALE_MS = 1000 * 60 * 3
export const INCENTIVE_CAMPAIGN_TYPE_REVALIDATION = 'REVALIDATION'
export const INCENTIVE_TARGET_TYPE_PARTNER = 'PARTNER'
